// French copy, namespace `reports`: the passes history, a pass's report (screen
// and PDF export) and the errors of the report routes. The report's content
// itself is written by the agent and stays in the language it was written in.

export const reports = {
  list: {
    pageTitle: "Passages — Hune",
    subject: "vos passages",
    workspaceBanner: { before: "Passages de l’espace client ", after: " (lecture seule)." },
    eyebrow: "Historique",
    lede: "Chaque passage de l’agent est conservé avec ses sources et les leads qu’il a déposés. Le pipeline reste la vue de travail ; ces rapports en sont la trace vérifiable.",
    title: "Passages.",
    titleFor: (name: string) => `Passages — ${name}.`,
    emptyWorkspace: "Aucun passage enregistré pour cet espace client.",
    empty: "Aucun passage enregistré pour l’instant.",
    firstPass: "Lancer un premier passage",
    tableLabel: "Passages enregistrés",
    columns: { pass: "Passage", startedAt: "Lancé le", status: "État", report: "Rapport" },
    source: { radar: "veille", manual: "manuel" },
    open: "Consulter",
    openLabel: "Consulter le rapport",
  },
  detail: {
    pageTitle: "Rapport — Hune",
    subject: "ce rapport",
    back: "Passages",
    notFound: {
      title: "Rapport introuvable.",
      body: "Ce passage n’existe pas, ou il n’est pas accessible depuis votre compte.",
      label: "Voir les passages",
    },
    failed: (reason: string) => `Cette analyse a échoué : ${reason}.`,
    unknownReason: "raison inconnue",
    unreadable: "Le rapport enregistré est illisible. Relancez une analyse.",
    pending: "Cette analyse n’est pas terminée. Revenez un peu plus tard.",
  },
  // Labels of the report, shared by the screen and the PDF export.
  report: {
    done: "Analyse terminée",
    opportunities: "Opportunités retenues",
    averagePriority: "Priorité moyenne",
    prioritySegment: "Segment prioritaire",
    strategy: "Stratégie de recherche",
    strategyTitle: "Pourquoi ces indices ?",
    target: "Cible",
    targetTitle: "Le contexte à privilégier",
    decisionMaker: "Décideur",
    desiredProgress: "Progrès recherché",
    favorableEvent: "Événement favorable",
    priorities: "Priorités",
    prioritiesTitle: "Les conversations à ouvrir au bon moment.",
    clue: "Indice observé",
    relevance: "Pertinence",
    momentum: "Fenêtre actuelle",
    draft: "Brouillon de message",
    toVerify: (note: string) => `À vérifier : ${note}`,
    trends: "Tendances récurrentes",
    trendsTitle: "Ce qui se dessine sur le marché.",
    nextSequence: "Prochaine séquence",
    caveats: "Cadre d’utilisation",
    score: { strong: "Fort", promising: "Prometteur", toConfirm: "À valider" },
  },
  // Screen only: actions around the report.
  view: {
    copyLink: "Copier le lien",
    exportPdf: "Exporter en PDF",
    exportFailed: "L’export PDF a échoué.",
    exportFailedRetry: "L’export PDF a échoué. Réessayez dans un instant.",
    defaultFilename: "rapport-hune.pdf",
    print: "Imprimer",
    copy: "Copier",
    sourceDetails: "Consulter la source et l’analyse",
    observation: "Observation",
    contactRoute: "Voie de contact",
    feedback: {
      label: (organization: string) => `Pertinence de ${organization}`,
      prompt: "Pertinent ?",
      relevant: "Opportunité pertinente",
      offTarget: "Opportunité hors sujet",
    },
  },
  pdf: {
    subject: (url: string) => `Analyse de marché — ${url}`,
    quote: (text: string) => `« ${text} »`,
    source: "Source",
    whoToContact: "Qui contacter",
    /** File name slug when the offer has no usable name (ASCII). */
    filenameFallback: "rapport",
  },
  errors: {
    signIn: "Connectez-vous.",
    signInToExport: "Connectez-vous pour exporter un rapport.",
    notFound: "Rapport introuvable.",
    invalidId: "Identifiant de rapport invalide.",
    notFoundOrPending: "Rapport introuvable ou analyse non terminée.",
    unreadable: "Le rapport enregistré est illisible.",
  },
};
